import { render, staticRenderFns } from "./LogisticsState.vue?vue&type=template&id=35339000&scoped=true&"
import script from "./LogisticsState.vue?vue&type=script&lang=js&"
export * from "./LogisticsState.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsState.vue?vue&type=style&index=0&id=35339000&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35339000",
  null
  
)

export default component.exports